import { apiEndPoint } from "./endPoint";

export const getOpenAIAssistantConversation = async (
  threadId: string,
  token: string
) => {
  const url = `${apiEndPoint}/getOpenAIAssistantConversation/${threadId}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return "エラーが発生しました: ${err.message}";
  }
};
